import styled from 'styled-components';

export const Pre = styled.pre`
    padding: 16px;
    white-space: pre-line;
    background: #eee;
    border: 1px dashed #e5e5e5;
`;
